import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './layout/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { CustomerLayoutComponent } from './module/customer/customer-layout/customer-layout.component';
import { DriverLayoutComponent } from './module/driver/driver-layout/driver-layout.component';
import { AuthGuard } from './shared/services/auth.guard';
import { AboutUsComponent } from './layout/about-us/about-us.component';
import { ContactUsComponent } from './layout/contact-us/contact-us.component';
import { HowItWorksComponent } from './layout/how-it-works/how-it-works.component';
import { CareerComponent } from './layout/career/career.component';
import { InvestorComponent } from './layout/investor/investor.component';
import { SafetyComponent } from './layout/safety/safety.component';
import { HelpAndSupportComponent } from './layout/help-and-support/help-and-support.component';
import { CareerDetailComponent } from './layout/career-detail/career-detail.component';
import { SiteLayoutComponent } from './layout/site-layout/site-layout.component';
import { BlogComponent } from './layout/blog/blog.component';
import { BlogDetailComponent } from './layout/blog-detail/blog-detail.component';
import { Verification } from './shared/services/verification.guard';
import { DeleteRequestUserComponent } from './layouts/delete-request-user/delete-request-user.component';
import { TermConditionComponent } from './layouts/term-condition/term-condition.component';
import { PrivacyPolicyComponent } from './layouts/privacy-policy/privacy-policy.component';


const routes: Routes = [


  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'home', redirectTo: '', pathMatch: 'full' },
      { path: 'about-us', component: AboutUsComponent },
      { path: 'contact-us', component: ContactUsComponent },
      { path: 'how-it-works', component: HowItWorksComponent },
      { path: 'career', component: CareerComponent },
      { path: 'career-detail/:id', component: CareerDetailComponent },
      { path: 'investors', component: InvestorComponent },
      { path: 'safety', component: SafetyComponent },
      { path: 'blog', component: BlogComponent },
      { path: 'help', component: HelpAndSupportComponent },
      { path: 'blog-detail/:id', component: BlogDetailComponent },
      { path: 'news-detail/:id', component: BlogDetailComponent }, 
    ]
  },
  {
    path: 'delete-user-request',
    component: DeleteRequestUserComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  // {
  //   path: 'term-condition',
  //   redirectTo: 'terms-and-conditions',
  //   pathMatch: 'full'
  // },
  {
    path: 'term-condition',
    component: TermConditionComponent
  },
  {
    path: 'terms-and-conditions',
    component: TermConditionComponent
  },


  {
    path: 'auth',
    children: [
      { path: '', loadChildren: () => import('./module/auth/auth.module').then(m => m.AuthModule) },
      { path: '**', component: PageNotFoundComponent },
    ]
  },
  {
    path: 'customer',
    component: CustomerLayoutComponent,
    // resolve:{userData:UserDataResolverService},
    canActivate: [AuthGuard, Verification],
    children: [
      { path: '', loadChildren: () => import('./module/customer/customer.module').then(m => m.CustomerModule) },
      { path: 'change-password', loadChildren: () => import('./shared/components/change-password/change-password.module').then(m => m.ChangePasswordModule) },
      { path: '**', component: PageNotFoundComponent }
    ]
  },
  {
    path: 'driver',
    // resolve:{userData:UserDataResolverService},
    component: DriverLayoutComponent,
    canActivate: [AuthGuard, Verification],
    children: [
      { path: '', loadChildren: () => import('./module/driver/driver.module').then(m => m.DriverModule) },
      { path: 'change-password', loadChildren: () => import('./shared/components/change-password/change-password.module').then(m => m.ChangePasswordModule) },
      { path: '**', component: PageNotFoundComponent }
    ]
  },
  { path: '**', component: PageNotFoundComponent },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
